import * as React from 'react';
import * as styles from './styles.css';
import { Checkbox } from '../../../Checkbox';
import { IDropdownOption } from '../../../../types/dropdown';
import { Typography } from '../../../Typography';

interface IDropdownProps {
  list: IDropdownOption[];
  isMultiselect: boolean;
  checkIsOptionSelected: (item: IDropdownOption) => boolean;
  handleSelect: (state: boolean, item: IDropdownOption) => void;
}

//TODO: Добавить отрисовку списка, когда пользователь может выбрать только один option из списка (isMultiselect === false)
export const Dropdown: React.FC<IDropdownProps> = ({ list, handleSelect, checkIsOptionSelected }) => {
  return (
    <div className={styles['list']}>
      <ul className={styles['options']}>
        {list.map(item => {
          return (
            <li className={styles['options-checkbox']} key={item.value}>
              <Checkbox
                isChecked={checkIsOptionSelected(item)}
                setChecked={state => handleSelect(state, item)}
                label={item.label}
                id={item.value}
              />
            </li>
          );
        })}
        {!list.length && (
          <li className={styles['not-found']}>
            <Typography.Text level={3}>Ничего не найдено</Typography.Text>
          </li>
        )}
      </ul>
    </div>
  );
};
